import React, { Component } from "react";
import { Vibration } from "react-native-web";
import TabsNavigator from "../components/Main/TabsNavigator";
import PrmFilters from "../components/Main/PrmFilters";
import BottomView from "../components/Main/MapSection/BottomView";
import ReportList from "../components/Main/ReportSection/ReportList";
import MapView from "../components/Main/MapSection/MapView";
import GoogleMapView from "../components/Main/MapSection/GoogleMapView";
import OperatorsList from "../components/Main/OperatorsSection/OperatorsList";

//const height = window.innerHeight;

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab:
        this.props.location.state && this.props.location.state.mainTab
          ? this.props.location.state.mainTab
          : 0,
      map: "Mapbox",
      selectedPassenger: null
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleMapChange = this.handleMapChange.bind(this);
    this.handlePinClick = this.handlePinClick.bind(this);
    this.handleMapClick = this.handleMapClick.bind(this);
  }

  handleTabChange(tabNum) {
    this.setState({ tab: tabNum });
    this.props.history.replace({ state: { mainTab: tabNum } });
  }

  handleMapChange(map) {
    this.setState({ map: map });
  }

  handlePinClick(passenger) {
    this.setState({ selectedPassenger: passenger });
    Vibration.vibrate(50);
  }

  handleMapClick() {
    if (this.state.selectedPassenger) {
      this.setState({ selectedPassenger: null });
    }
  }

  tabsHandler() {
    switch (this.state.tab) {
      case 0:
        return <ReportList />;
      case 1:
        return this.state.map === "Google" ? (
          <>
            <GoogleMapView
              onPinClick={this.handlePinClick}
              onMapClick={this.handleMapClick}
            />
            <BottomView selectedPassenger={this.state.selectedPassenger} />
          </>
        ) : (
          <>
            <MapView
              onPinClick={this.handlePinClick}
              onMapClick={this.handleMapClick}
            />
            <BottomView selectedPassenger={this.state.selectedPassenger} />
          </>
        );
      case 2:
        return <OperatorsList />;
      default:
        return <ReportList index={0} value={this.state.tab} />;
    }
  }

  render() {
    console.log("PROPS: ", this.props);

    return (
      <div style={{ width: "100%", zIndex: 1, overflowY: "hidden" }}>
        <TabsNavigator
          value={this.state.tab}
          onTabChange={this.handleTabChange}
        />
        <PrmFilters map={this.state.map} onMapChange={this.handleMapChange} />
        {this.tabsHandler()}
      </div>
    );
  }
}

export default Main;
